import { useState, useCallback } from 'react'
import type { FieldDef, FieldValues } from '../gallery/fieldTypes'
import { getDefaultValues } from '../gallery/fieldTypes'

export function useExampleEditor(fields: FieldDef[]) {
  const defaults = getDefaultValues(fields)
  const [values, setValues] = useState<FieldValues>(defaults)
  const [replayKey, setReplayKey] = useState(0)

  const setValue = useCallback((id: string, value: any) => {
    setValues((prev) => ({ ...prev, [id]: value }))
  }, [])

  const resetAll = useCallback(() => {
    setValues(getDefaultValues(fields))
    setReplayKey((k) => k + 1)
  }, [fields])

  const replay = useCallback(() => {
    setReplayKey((k) => k + 1)
  }, [])

  return { values, setValue, resetAll, replayKey, replay }
}
